import Input from "ds/Input";

import { FormConfigType } from "../type";

import FormKeyValue from "./FormKeyValue";
import FormRadioGroupsInput from "./FormRadioGroupsInput";
import FormSeparatorInput from "./FormSeparatorInput";
import FormSwitchInput from "./FormSwitchInput";
import FormUnkownInput from "./FormUnkownInput";
import { Textarea } from "./styles";

export const getFormInputComp = (config: FormConfigType) => {
  switch (config.inputType) {
    case "textarea":
      return Textarea;
    case "default":
      return Input;
    case "radio":
      return FormRadioGroupsInput;
    case "switch":
      return FormSwitchInput;
    case "keyValue":
      return FormKeyValue;
    case "separator":
      return FormSeparatorInput;
    default:
      return FormUnkownInput;
  }
};
